import { forwardRef } from "react";
import { useTheme } from "@mui/material/styles";
import { Avatar as MUIAvatar, AvatarProps } from "@mui/material";

// ----------------------------------------------------------------------

type AvatarColor =
  | "default"
  | "primary"
  | "secondary"
  | "info"
  | "success"
  | "warning"
  | "error";

// ----------------------------------------------------------------------

export interface Props extends AvatarProps {
  color?: AvatarColor;
  customColor?: string;
}

const Avatar = forwardRef<HTMLDivElement, Props>(
  ({ color = "default", customColor, children, sx, ...other }, ref) => {
    const theme = useTheme();

    if (color === "default" && !customColor) {
      return (
        <MUIAvatar ref={ref} sx={sx} {...other}>
          {children}
        </MUIAvatar>
      );
    }

    return (
      <MUIAvatar
        ref={ref}
        sx={{
          fontWeight: theme.typography.fontWeightMedium,
          backgroundColor: customColor
            ? customColor
            : theme.palette[color].main,
          color: customColor
            ? theme.palette.getContrastText(customColor)
            : theme.palette[color].contrastText,
          ...sx,
        }}
        {...other}
      >
        {children}
      </MUIAvatar>
    );
  }
);

export default Avatar;
